import React, { useEffect, useState } from "react";
import { pageListLength } from "../constants";

export interface PaginationComponentProps {
  page: number;
  row?: number;
  totalResults: number;
  totalPages: number;
  pageHandler: (page: number) => void;
}

export const PaginationComponent: React.FC<PaginationComponentProps> = ({
  page,
  totalPages,
  totalResults,
  pageHandler,
}) => {
  const [pageList, setPageList] = useState<number[]>([]);
  const length = 4;

  useEffect(() => {
    setPageList([]);
    for (
      let index = page - pageListLength;
      index <=
      (totalPages < page + pageListLength ? totalPages : page + pageListLength);
      index++
    ) {
      if (index > 0) setPageList((current) => [...current, index]);
    }
  }, []);

  return (
    <ul className={`text-center pt-3 flex flex-wrap gap-x-3 justify-center`}>
      <li className={`paginator`}>
        <button
          type="button"
          className={`${page < 2 ? `pointer-events-none` : ``} px-2`}
          onClick={() => pageHandler(page - 1)}
        >
          <i className="fa-thin fa-angle-left"></i>
        </button>
      </li>
      {pageList.map((_page) => {
        return (
          <li className={`paginator`} key={`pagination-${_page}`}>
            <button
              type="button"
              className={`${page === _page ? `font-bold` : ``}`}
              onClick={() => pageHandler(_page)}
            >
              {_page}
            </button>
          </li>
        );
      })}
      <li className={`paginator`}>
        <button
          type="button"
          className={`${page >= totalPages ? `pointer-events-none` : ``} px-2`}
          onClick={() => pageHandler(page + 1)}
        >
          <i className="fas fa-angle-right"></i>
        </button>
      </li>
    </ul>
  );
};
